export const INST_CODE_FOR_SILENT_AUTH_KEY = "instCodeForSilentAuth";
export const INST_CODE_KEY = "instCode";
